export default "__VITE_ASSET__d373ebe3__"